import { TextField as _TextField } from '../../../components';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
    text: string;
    onChangeText: (text: string) => void;
    placeholder?: string;
    className?: string;
    margin?: string;
};

export function TextField({ text, onChangeText, margin, ...props }: Props) {
    return (
        <div className={margin ?? 'mt-20'}>
            <_TextField {...props} value={text} onChangeValue={onChangeText} />
        </div>
    );
}
